import { Location, SlotItemInterface, TransportItemInterface } from '../../../types/interfaces'
import classes from './GMapForMarker.module.sass'
import { useGMapForMarker } from './hooks/useGMapForMarker'

type Props = {
  center: Location
  item: SlotItemInterface | TransportItemInterface
}

export const GMapForMarker = ({ center, item }: Props) => {
  useGMapForMarker(center, item)

  return <div id="map"  className={classes.Map} style={{zIndex:1}} />
}
